import Vue from 'vue'

// TODO @TFU: Exchange with native useQuasar composable from quasar package once upgraded to Vue 3.
export function useQuasar () {
    return new Vue().$q
}
